<template>
  <div class="slot col-6 col-sm-4 col-lg-3 col-xl-2 pr-1">
    <a href="#" class="btn btn-primary js-time" @click.prevent="$emit('choose', s.slots)">
      {{ s.label }}
      <span class="badge badge-pill badge-light text-primary ml-1" v-if="s.count > 1">{{ s.count }}</span>
    </a>
  </div>
</template>

<script charset="utf-8">
export default {
  name: "TimeSlot",
  props: ["s"],
};
</script>
